import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sumBy',
    standalone: false
})
export class SumByPipe implements PipeTransform {
  transform(items: any[], prop: string): number {
    if (!Array.isArray(items)) return 0;
    return items.reduce((sum, item) => sum + (item[prop] || 0), 0);
  }
}
